// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SSiw","type":"styles_type__2RiWS","choices":"styles_choices__1q_W1"};